import styled from "@emotion/styled";

export const PickerSelectWrap = styled.div`
  padding: 0 5px 5px;
`;

export const ColorPickerWrap = styled.div`
  .ui-color-picker {
    width: 100%;
    margin: 0;
    padding-top: 10px;
    background-color: transparent;
    .input-group {
      display: none;
    }
  }
`;